import {AsyncPipe, NgForOf} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {NbIconModule} from '@nebular/theme';
import {BreadcrumbDto} from 'compob2b-libs';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss',
    imports: [
        AsyncPipe,
        RouterLink,
        NgForOf,
        NbIconModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent {

  @Input() breadCrumbs: Observable<BreadcrumbDto[]>;
  @Input({required: true}) controller: string;
  @Input() action: string;
  @Input({required: true}) param: string;

  params(breadCrumb: BreadcrumbDto): object {
    const ret = {};
    ret[this.param] = breadCrumb.id;
    return ret;
  }

  link(breadCrumb: BreadcrumbDto): any {
    if (this.action && breadCrumb.id) {
      return [this.controller, breadCrumb.id, this.action];
    }

    return [this.controller];
  }
}
